import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FormActions } from '../../components/form';
import { Search } from '../../components/search/Search.tsx';
import { SearchContextProvider } from '../../contexts/search.tsx';
import RecipesHeader from './header.tsx';

const RecipesPage = () => {
    const navigate = useNavigate();
    return (
        <SearchContextProvider>
            <RecipesHeader />
            <Search disableAlimentSearch disableMealSearch />
            <FormActions
                mainAction={() => { navigate("/recipes/create"); }}
                mainActionText="Create"
            />
        </SearchContextProvider>
    );
};

export default RecipesPage;
